import { Card, Tag } from 'antd';
import DsIcon from '@/components/Layout/DsIcon';
import { ChannelType } from '@/proto/agentplatform/v1/channel_pb';
import { CHANNEL_TYPES } from './helpers';

interface ChannelTypeSidebarProps {
  activeType: ChannelType;
  onChange: (type: ChannelType) => void;
  /** 各类型账号计数（用于右侧徽标） */
  countsByType: Record<number, number>;
}

/** 左侧渠道类型导航（WebSocket / 飞书 / QQ + 计数），对齐参考页。 */
export default function ChannelTypeSidebar({
  activeType,
  onChange,
  countsByType,
}: ChannelTypeSidebarProps) {
  return (
    <Card size="small" className="type-side" styles={{ body: { padding: 12 } }}>
      <div className="type-side-title">渠道类型</div>
      {CHANNEL_TYPES.map((t) => {
        const active = activeType === t.type;
        return (
          <div
            key={t.type}
            className={`type-item ${active ? 'is-active' : ''}`}
            onClick={() => onChange(t.type)}
          >
            <DsIcon name={t.icon} size={16} className="type-icon" />
            <div className="type-text">
              <div className="type-label">{t.label}</div>
              <div className="type-desc">{t.desc}</div>
            </div>
            <Tag color={active ? 'processing' : 'default'}>{countsByType[t.type] ?? 0}</Tag>
          </div>
        );
      })}
    </Card>
  );
}
